import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { getStoredAccessToken, hasStoredAuthToken } from '@core/utils/auth-token.util';
import { catchError, throwError } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  if (req.url.includes('storage.googleapis.com')) {
    return next(req);
  }

  if (req.url.includes('/auth/') || !hasStoredAuthToken()) {
    return next(req);
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${getStoredAccessToken()}`,
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  if (!req.url.includes('upload-chunk') && !req.url.includes('upload') &&  !req.url.includes('import')) {
    headers['Content-Type'] = 'application/json';
  }

  const authReq = req.clone({ setHeaders: headers });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 401 ||
        (error.status === 422 && error.error?.message?.includes('unauthenticated'))
      ) {
        injector.get(AuthService).forceLogout();
      }

      return throwError(() => error);
    })
  );
};
